import { IBill, ICreateBill, IUpdateBill } from "../models/IBill";
import { configWithUserToken } from "./config";

export const postBill = (bill: ICreateBill) => {
  return configWithUserToken.post<IBill>("Bill", bill, {
    headers: { "Idempotency-Key": crypto.randomUUID() },
  });
};

export const getBillsByRestaurant = (
  restaurantId: string,
  month: number | null,
  year: number,
  isBillPaid?: boolean,
  isBillEnabled?: boolean,
) => {
  let url = `Bill/${restaurantId}?year=${year}`;
  if (month !== null) url += `&month=${month}`;
  if (isBillPaid !== undefined) url += `&isBillPaid=${isBillPaid}`;
  if (isBillEnabled !== undefined) url += `&isBillEnabled=${isBillEnabled}`;
  return configWithUserToken.get<IBill[]>(url);
};

export const putBill = (bill: IUpdateBill) => {
  return configWithUserToken.put<IBill>("Bill", bill);
};